import { SynastryForm } from '@/app/pages/SynastryPage/SynastryForm/SynastryForm'
import { SynastryList } from '@/app/pages/SynastryPage/SynastryList/SynastryList'
import { SynastryV2 } from '@/app/pages/SynastryPage/SynastryV2/SynastryV2'
import type { FunctionalComponent } from 'preact'
import { Route, Switch } from 'wouter-preact'

export const SynastryPage: FunctionalComponent = () => {
  return (
    <Switch>
      <Route path='/'>
        <SynastryList />
      </Route>

      <Route path='/create'>
        <SynastryForm />
      </Route>

      <Route path='/:type/:id'>
        <SynastryV2 />
      </Route>
    </Switch>
  )
}
